import {
  checkInHacker,
  checkInJudge,
  fetchUserApplicationStatus,
  updateMealInfoList,
} from './mongoDataOperations';

export function formatDate(dateString) {
  if (!dateString) return null;
  const date = new Date(dateString);
  return `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date
    .getDate()
    .toString()
    .padStart(2, '0')}-${date.getFullYear()}`;
}

export function formatDateTime(dateString) {
  if (!dateString) return null;
  const date = new Date(dateString);
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}

export function calculateAge(dob) {
  if (!dob) return null;
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }
  return age;
}

export function getMeal() {
  const hour = new Date().getHours();

  if (hour > 6 && hour < 10) {
    return 'Breakfast';
  } else if (hour > 11 && hour < 14) {
    return 'Lunch';
  } else if (hour > 16 && hour < 20) {
    return 'Dinner';
  } else {
    return null;
  }
}

export function getMealCode() {
  const day = new Date()
    .toLocaleString('en-us', { weekday: 'short' })
    .toLowerCase();
  const meal = getMeal()?.toLowerCase();

  if (meal === null || meal === undefined) {
    return null;
  }

  return `${day}-${meal}`;
}

export async function updateUsedMeals(hacker_id, hacker_record, mealCode) {
  const newUsedMeals = hacker_record?.meal_info?.usedMeals || [];
  newUsedMeals.push(mealCode);

  try {
    await updateMealInfoList(
      hacker_id,
      newUsedMeals,
      hacker_record?.meal_info?.dietaryRestrictions
    );
  } catch (error) {
    console.error('Error setting meal:', error);
    return;
  }
}

export async function checkInHackerHelper(
  hacker_id,
  organizer_user,
  setStatusMessage,
  setCheckInIsLoading,
  hacker_record
) {
  const organizerEmail = organizer_user.attributes.email;

  try {
    const application_status = await fetchUserApplicationStatus(hacker_id);
    if (application_status.status !== 'admission_confirmed') {
      setStatusMessage({
        type: 'error',
        text: 'Check in failed! Hacker is not admitted.',
      });
      setCheckInIsLoading(false);
      return false;
    }

    await checkInHacker(hacker_id, organizerEmail, hacker_record);

    setStatusMessage({
      type: 'success',
      text: 'Check in successful!',
    });
    setCheckInIsLoading(false);
    return true;
  } catch (error) {
    console.error('Error checking in hacker:', error);
    setStatusMessage({
      type: 'error',
      text: 'Check in failed! Please try again.',
    });
    setCheckInIsLoading(false);
    return false;
  }
}

export async function checkInJudgeHelper(
  judge_id,
  organizerUser,
  setStatusMessage,
  setCheckInIsLoading,
  judge_record
) {
  try {
    const organizerEmail = organizerUser.attributes.email;

    checkInJudge(judge_id, organizerEmail, judge_record);

    setStatusMessage({
      type: 'success',
      text:
        'Check in successful for ' +
        judge_record?.application_info?.first_name +
        ' ' +
        judge_record?.application_info?.last_name,
    });
    setCheckInIsLoading(false);
    return;
  } catch (error) {
    console.error('Error checking in judge:', error);
    setStatusMessage({
      type: 'error',
      text: 'Check in failed! Please try again.',
    });
    setCheckInIsLoading(false);
    return;
  }
}
